import React from "react";
import { FilterComponent } from "./";
import { buildTableValues } from "../../utils/customization/filter";

// prettier-ignore
const R_COEFS = [
  -34.691, 165.108, -323.472, 330.797, -181.098, 45.048, -1.216, 0.085, 0.23, 0.207, 0
];
// prettier-ignore
const ALL_COEFS = [
  29.465, -163.603, 385.872, -501.084, 387.454, -180.057, 49.322, -8.528, 0.589, 1.57, 0
];

let tableValues:
  | {
      r: string;
      gb: string;
    }
  | undefined;

const Greenshrimp: FilterComponent = ({ id, height, width }) => {
  if (!tableValues) {
    tableValues = {
      gb: buildTableValues(ALL_COEFS),
      r: buildTableValues(R_COEFS, ALL_COEFS),
    };
  }

  return (
    <filter
      id={id}
      colorInterpolationFilters="sRGB"
      filterUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={width}
      height={height}
    >
      <feComponentTransfer in="SourceGraphic">
        <feFuncR type="table" tableValues={tableValues.r} />
        <feFuncG type="table" tableValues={tableValues.gb} />
        <feFuncB type="table" tableValues={tableValues.gb} />
        <feFuncA type="identity" />
      </feComponentTransfer>
    </filter>
  );
};

export default Greenshrimp;
